// extracted by mini-css-extract-plugin
export default {"birthDateInput":"RegisterAuditorFormStepTwo_birthDateInput__u4Sjq","titleQuestion":"RegisterAuditorFormStepTwo_titleQuestion__39tqY","note":"RegisterAuditorFormStepTwo_note__0EZc7"};